import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { ApiKeyOrGetter } from "./services/GeneralService";

interface PermissionsContextType {
  apiKey: ApiKeyOrGetter;
  setApiKey: (apiKey: ApiKeyOrGetter) => void;
  companyId: number | null;
}

const PermissionsContext = createContext<PermissionsContextType | undefined>(
  undefined
);

export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (context === undefined) {
    throw new Error("usePermissions must be used within a PermissionsProvider");
  }
  return context;
};

export const PermissionsProvider: React.FC<{
  children: ReactNode;
  apiKey: ApiKeyOrGetter;
  companyId: number | null;
}> = ({ children, apiKey, companyId }) => {
  const [key, setKey] = useState<ApiKeyOrGetter>(apiKey);
  useEffect(() => {
    if (apiKey) {
      console.log(
        "[PermissionsProvider] API key updated:",
        typeof apiKey === "string"
          ? `admin key (${apiKey.substring(0, 20)}...)`
          : "auth context object"
      );
      setKey(apiKey);
    }
  }, [apiKey]);
  return (
    <PermissionsContext.Provider
      value={{ apiKey: key, setApiKey: setKey, companyId }}>
      {children}
    </PermissionsContext.Provider>
  );
};
